<template>
  <v-container fluid>
    <attendance-report-container-view />
  </v-container>
</template>

<script>
  export default {
    components: {
      AttendanceReportContainerView: () => import('@/components/hris/reports/attendance/AttendanceReports'),
    },
  }
</script>
